import { Fragment } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';

import s from './MenuDesplegable.module.scss';
import menuDesplegableItems, { AGENDA_DE_TURNOS, ONLINE_TRANSACTIONS } from './menuItems';
import {
  utilInformationLinks,
  medicalCenterLinks,
  preventionLinks,
  instructionsLinks,
  contactLinks,
} from './menuDesplegable.utils';
import { createSessionDOC24Action } from '../../actions/users/doc24';
import {
  selectPractitionerDoc24,
  userHasDOC24Permission as userHasDOC24PermissionSelector,
} from '../../selectors/users';
import Loading from '../Loading/Loading';
import { getNormalizeCensuseName } from '../../utils/utils';

const MenuDesplegable = ({ isUserAuthenticated, userPermissions }) => {
  const userHasDOC24Permission = useSelector(userHasDOC24PermissionSelector);
  const isLoading = useSelector((state) => state.loading.wait);
  const practitionerDoc24 = useSelector(selectPractitionerDoc24);
  const dispatch = useDispatch();

  const renderLoggedMenu = () => {
    const permissions = userPermissions?.leftNavigationAndMenuButtons;
    if (permissions && permissions.length > 0) {
      const staticMenu = menuDesplegableItems;

      for (let i = 0; i < staticMenu.length; i++) {
        const sectionMenu = staticMenu[i].section.menu;
        staticMenu[i].section.menu = sectionMenu.filter((sm) =>
          permissions.some(
            (p) => p.id === sm.id || (sm.id === AGENDA_DE_TURNOS && userHasDOC24Permission),
          ),
        ); // filter by permissions
      }

      const loggedMenuComponent = staticMenu.map((menuItem, index) => {
        if (menuItem.section.menu.length > 0) {
          return (
            <div
              key={index.toString()}
              className={`col-12 col-lg-2 col-xl-2 py-4 px-3 rounded ${s.loggedMenuBackgroundColor}`}
            >
              <h6>
                <strong>{menuItem.section.description}</strong>
              </h6>
              {menuItem.section.menu.map((sectionMenuItem, index) => {
                const handleOnClick = (e) => {
                  if (sectionMenuItem.type !== 'route') {
                    e.preventDefault();
                    dispatch(createSessionDOC24Action(practitionerDoc24));
                  }
                };
                return (
                  <Nav.Link
                    eventKey={sectionMenuItem.id}
                    onClick={handleOnClick}
                    key={index.toString()}
                  >
                    <Link to={sectionMenuItem.route} data-test-id={sectionMenuItem.description}>
                      {menuItem.section.id === ONLINE_TRANSACTIONS
                        ? getNormalizeCensuseName(sectionMenuItem.description)
                        : sectionMenuItem.description}
                    </Link>
                  </Nav.Link>
                );
              })}
            </div>
          );
        }
      });
      return loggedMenuComponent;
    }
  };

  const loggedMenu = renderLoggedMenu();

  const usefulInformationLinks = !isUserAuthenticated
    ? utilInformationLinks.filter((link) => link.private === false)
    : utilInformationLinks;

  return (
    <div className='col-12 p-2 text-white'>
      <div className={`${s.navLinks} col-10 mx-auto d-lg-flex d-xl-flex justify-content-center`}>
        <div className='col-12 col-lg-2 col-xl-2 py-4 px-2'>
          <h6>
            <strong>INFORMACIÓN ÚTIL</strong>
          </h6>
          {usefulInformationLinks.map(({ isExternalLink, path, title }) => (
            <Fragment key={title}>
              {isExternalLink ? (
                <Nav.Link
                  className='text-white'
                  eventKey={title}
                  href={path}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  {title}
                </Nav.Link>
              ) : (
                <Nav.Link className='text-white' eventKey={title} href={path}>
                  <Link to={path}>{title}</Link>
                </Nav.Link>
              )}
            </Fragment>
          ))}
        </div>

        <div className='col-12 col-lg-2 col-xl-2 py-4 px-2'>
          <h6>
            <strong>CENTROS MÉDICOS</strong>
          </h6>
          {medicalCenterLinks.map(({ isExternalLink, title, path }) => (
            <Fragment key={title}>
              {isExternalLink ? (
                <Nav.Link
                  className='text-white'
                  eventKey={title}
                  href={path}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  {title}
                </Nav.Link>
              ) : (
                <Nav.Link className='text-white' eventKey={title} href={path}>
                  <Link to={path}>{title}</Link>
                </Nav.Link>
              )}
            </Fragment>
          ))}

          <br />
          <br />

          <h6>
            <strong>PREVENCIÓN</strong>
          </h6>
          {preventionLinks.map(({ title, path }) => (
            <Nav.Link eventKey={title} key={title}>
              <Link to={path}>{title}</Link>
            </Nav.Link>
          ))}
        </div>

        <div className='col-12 col-lg-2 col-xl-2 py-4 px-2'>
          <h6>
            <strong>INSTRUCTIVOS</strong>
          </h6>
          <a>Centro de atención al prestador</a>
          {instructionsLinks.map(({ isExternalLink, title, path, hasInitalSpace }) => (
            <>
              {isExternalLink ? (
                <Nav.Link
                  className='text-white '
                  eventKey={title}
                  href={path}
                  target='__blank'
                  rel='noopener noreferrer'
                  key={title}
                >
                  {Boolean(hasInitalSpace) && <div className={s.initialSpaceDiv}>&emsp;</div>}
                  {title}
                </Nav.Link>
              ) : (
                <Nav.Link className='text-white' eventKey={title} href={path}>
                  <Link to={path}>{title}</Link>
                </Nav.Link>
              )}
            </>
          ))}

          <div className='py-4'>
            <h6>
              <strong>CONTACTO</strong>
            </h6>
            {contactLinks.map(({ title, path }) => (
              <Nav.Link eventKey={title} key={title}>
                <Link to={path}>{title}</Link>
              </Nav.Link>
            ))}
          </div>
        </div>

        {isUserAuthenticated && loggedMenu}
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default MenuDesplegable;
